const utils = require('frontend-controller/lib/utils');
module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'customerContacts',
        showHead: true,
        showIDs: true,
        // showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '105px',
        },
        rowActions: {
            edit: true,
            customs: [
                {
                    buttonType: 'showMove',
                    mode: 'toCustomer',
                },
                // {
                //     buttonType: 'delete',
                //     neutral: true,
                // }
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_customerContacts': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'customerContactID',
                direction: 'asc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_customerContacts:create', }
                ]
            }
        },

        async showMove(rowID, rowData){
            const baseActionKey = 'showSelect_customer'
            await this.performAndStoreAction(
                `${baseActionKey}_inEffect`,
                this.prepareAction(baseActionKey, undefined, {
                    decisionOrigin: {
                        type: 'moveToCustomer',
                        customerContactID: rowID,
                        customerContact: rowData,
                    },
                }),
                true
            )
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'customerContacts':
                    const myCustomerID = ((this.model.parentEntityForTable || {}).baseFilters || {}).customerID
                    const foundCustomerID = ((entityData || {}).attributes || {}).customerID

                    if(myCustomerID && foundCustomerID && myCustomerID == foundCustomerID) {
                        if (insertPerformed && entityID && entityData) {
                            this.showEdit(entityID, entityData)
                        }
                    }
                    break;
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            const myCustomerID = ((this.model.parentEntityForTable || {}).baseFilters || {}).customerID

            if(
                refreshers[key] &&
                (
                    key === 'reconnect' ||
                    message.data.customerID == myCustomerID ||
                    (message.data.customerIDs || {})[myCustomerID]
                )
            ){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    },

    hooks: {
        async onDecision($element, options){
            let hideModalComponent = false
            if(options.decisionComponent.hasClass('base_modal_modal')) {
                hideModalComponent = options.decisionComponent
            }

            switch(options.decisionType){
                case 'submit':
                    const decisionOptions = (options || {}).decisionOptions || {}
                    const decisionOrigin = (options || {}).decisionOrigin || {}

                    const customerContact = (decisionOrigin.customerContact || {}).attributes || {}
                    const sourceCustomerID = customerContact.customerID
                    const targetCustomerID = decisionOptions.entityID || 0
                    const customerContactID = decisionOrigin.customerContactID

                    if(options.decisionComponent){
                        options.decisionComponent.closest('base_modal_modal', m => hideModalComponent = m)
                    }

                    if(targetCustomerID && customerContactID){

                        if(sourceCustomerID == targetCustomerID){
                            return this.performAction(
                                this.prepareAction('message', undefined, {
                                    messageDisplay: {
                                        message: 'error:customers.customerContacts.notAbleToMoveCustomerContactToTheVerySameCustomer'
                                    }
                                }, {
                                    statusControllerLoadingMessage: '',
                                    statusControllerSavingMessage:  ''
                                })
                            )
                        }

                        // NOTE: hide modal before projectTerms getting patched to avoid unwanted re-open of selectProject-modal via refresher.
                        await hideModalComponent.hide()
                        hideModalComponent = null

                        await this.performAction(
                            this.prepareAction('edit_customerContact', customerContactID, undefined, {
                                source: {
                                    submit: {
                                        data: {
                                            data: {
                                                attributes: {
                                                    customerID: targetCustomerID,
                                                }
                                            }
                                        }
                                    }
                                }
                            }),
                        )
                    }

                    // hide modal
                    if(hideModalComponent){
                        await hideModalComponent.hide()
                    }
                    break;

                case 'cancel':
                default:
                    // hide modal
                    if(hideModalComponent){
                        await hideModalComponent.hide()
                    }
                    break;
            }
        },
    },
}